<div class="mb-2">
  <div class="p-3 bg-light rounded d-flex flex-column flex-sm-row">
    <div class="text-bold align-self-sm-center">
      <span class="fa fa-square text-secondary me-2"></span>
      {{ request.workshop.title }}
    </div>
    <div
      class="ms-4 ms-sm-2 my-1 my-sm-0 align-self-sm-center"
      *ngIf="request.workshop.holdingDateJalali"
    >
      {{ request.workshop.holdingDateJalali }}
    </div>
    <div
      class="ms-4 ms-sm-2 my-1 my-sm-0 align-self-sm-center"
      *ngIf="request.workshop.holdingTypeTitle"
    >
      {{ request.workshop.holdingTypeTitle }}
    </div>
    <div
      class="ms-4 ms-sm-2 my-1 my-sm-0 align-self-sm-center"
      *ngIf="request.registrationDateJalali"
    >
      {{ requestDateLabel }}: {{ request.registrationDateJalali }}
    </div>
    <div
      class="p-1 rounded ms-4 my-1 my-sm-0 text-center text-sm-center ms-auto"
    ></div>
    <div class="d-flex">
      <div *ngIf="request.status === 1">
        <span class="fa fa-spinner text-warning"></span>
      </div>
      <div *ngIf="request.status === 2">
        <span class="fa fa-check text-success"></span>
      </div>
      <div *ngIf="request.status === 3">
        <span class="fa fa-ban text-danger"></span>
      </div>
      <div *ngIf="request.status === 4">
        <span class="fa fa-hourglass-end text-danger"></span>
      </div>
      <div class="ms-2" style="width: 60px">{{ request.statusTitle }}</div>
    </div>
  </div>
</div>
